// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import style from 'react-syntax-highlighter/dist/esm/styles/prism/darcula'
import gfm from 'remark-gfm'

import { S } from './styles';

function handleContextMenu(e: React.MouseEvent<HTMLElement>) {
  const allow = ['A', 'PRE', 'CODE']
  if (allow.includes((e.target as HTMLElement).tagName)) {
    e.stopPropagation();
  } else {
    e.preventDefault();
  }
}

const Image = (props: ComponentPropsWithRef<'img'>): JSX.Element => {
  return <S.Img
    alt=""
    {...props}
    draggable={false}
  />
}

export interface MarkdownProps extends ComponentPropsWithRef<'div'> {
  markdown: string;
  baseUrl?: string;
  mdImageUrl? :string;
  id?: string;
  checked?: boolean;
  setShowImgUpImg: (img: string) => void;
  setShowImgUp: (show: boolean) => void;
}

interface CodeProps extends React.ComponentPropsWithRef<'code'> {
  value: string;
  language: string;
}

const Code = ({ value = '', language }: CodeProps): JSX.Element => {
  return (
    <div>
      <SyntaxHighlighter
        style={{ ...style, backgroundColor: '' }}
        customStyle={{ backgroundColor: '' }}
        language={language}
        showLineNumbers={true}
      >
        {value.trimEnd()}
      </SyntaxHighlighter>
    </div>
  )
}

const Markdown = ({ markdown, baseUrl, id, setShowImgUpImg, setShowImgUp, ...props }: MarkdownProps): JSX.Element => {
  // const setShowImgUpImg = props.setShowImgUpImg;
  // const setShowImgUp = props.setShowImgUp;

  const handlePopUpImg = (img: any, e: any) => {
    e.stopPropagation();
    setShowImgUp(true);
    setShowImgUpImg(img);
  }

  const isChecked = () => {
    if (props.checked) {
      return props.checked
    } else {
      return false
    }
  };
  const checked = isChecked();

  const uriParser = (uri: string) => {
    if (uri.includes('./materials')) {
      return `${baseUrl}/${uri.slice(2)}`
    } else {
      return uri.indexOf('./') === 0 ? `${baseUrl}/${uri.slice(2)}` : uri
    }
  }

  const Link = (props: ComponentPropsWithRef<'a'>): JSX.Element => {
    const url = props.href?.[0] === '.' ? baseUrl + props.href : props.href;
    return <div><a {...props} target="_blank" href={url} rel="noreferrer" onContextMenu={handleContextMenu} /></div>
  }

  const ParsedHtml = ({ value }: any) => {
    const commentTagRegex = new RegExp(/<!--(?:.|\n|\r)*?-->/g)
    const imageTagRegex = new RegExp(/<img src="([^"]+)"/g)

    const sanitizedValue = value.replace(commentTagRegex, '');
    const result = imageTagRegex.exec(sanitizedValue) || [];

    const [isHovering, setIshovering] = useState(false);

    if (result[1]) {
      return (
        <>
          <S.ImgContainer>
            <S.Img
              alt="exam-img"
              src={`${uriParser(result[1])}`}
              draggable={false}
              onContextMenu={(handleContextMenu)}
              onMouseEnter={() => { setIshovering(true) }}
              onMouseOut={() => { setIshovering(false) }}
            />
            { isHovering ? <S.ImgZoomIn
              isMulti={true}
              onMouseEnter={() => { setIshovering(true) }}
              onMouseOut={() => { setIshovering(false) }}
              onClick={(e) => handlePopUpImg(`${uriParser(result[1])}`, e)}
            /> : null}
          </S.ImgContainer>
        </>
      )
    }

    return (
      <div><span dangerouslySetInnerHTML={{ __html: value }} /></div>
    );
  }

  const renderers = {
    image: Image,
    link: Link,
    html: ParsedHtml,
    code: Code,
    paragraph: (props: React.ComponentPropsWithRef<'p'>) => <p>{props.children}</p>
  }

  return (
    <div>
      <S.ExamWrapper
        data-testid="exam-experiment"
        className="view-all-content-wrapper-exam"
        id={id}
        onContextMenu={handleContextMenu}
        checked={checked}
        {...props}
      >
        <div>
          <S.ReactMarkdown
            source={markdown}
            transformImageUri={uriParser}
            transformLinkUri={uriParser}
            renderers={renderers}
            plugins={[gfm]}
          />
        </div>
        {
          markdown ? '' : (
            <S.WrapperLeft
              className="wrapper-left"
              dangerouslySetInnerHTML={{ __html: markdown }}
            />
          )
        }
      </S.ExamWrapper>
    </div>
  );
}

export default Markdown;
